import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import "./PropertyDetails.css";
import Tulsi1 from "./Images/tulsi1.jpg";
import Tulsi2 from "./Images/Tulsi2.jpg";
import Tulsi3 from "./Images/tulsi3.jpeg";
import Tulsi4 from "./Images/tulsi4.jpeg";
import Tulsi5 from "./Images/tulsi5.jpeg";
import Satyam1 from "./Images/satyam1.jpeg";
import Satyam2 from "./Images/Satyam2.jpeg";
import Satyam3 from "./Images/Satyam3.jpeg";
import Satyam4 from "./Images/Satyam4.jpeg";
import Satyam5 from "./Images/Satyam5.jpeg";
import Satyam6 from "./Images/Satyam6.jpeg";
import Golden1 from "./Images/Golden1.jpeg";
import Golden2 from "./Images/Golden2.jpeg";
import
{
  FaBed, FaBath, FaRulerCombined, FaMapMarkerAlt, FaPhone,
  FaWhatsapp, FaCalendarAlt, FaEnvelope, FaLink,
  FaTree, FaShieldAlt, FaShareAlt, FaHeart, FaCalendar,
  FaChartLine, FaFileAlt, FaEye, FaSave, FaUsers, FaClock,
  FaBuilding, FaHome, FaCity, FaParking, FaFacebook, FaTwitter,
  FaCopy, FaCheck
} from "react-icons/fa";

// Sample data with additional details
const properties = [
  {
    id: 101,
    title: "Tulsi Patra 3 BHK",
    price: "₹ 7.5 Crore",
    pricePerSqft: "₹ 23,438/sqft",
    plotArea: "625 OR 815  sqft",
    location: "Gadkhol Patiya opp.Aiyappa manidr, Ankleshwar",
    address: "Gadkhol Patiya Opp:Aiyappa manidr, Ankleshwar",
    image: Tulsi1,
    images: [
      Tulsi1,
      Tulsi2 ,
      Tulsi3,
      Tulsi4,
      Tulsi5,
     
      
    ],
    type: "Row House - For Sale",
    description: "Experience modern and comfortable living at Tulsi Patra, a thoughtfully designed residential development located in a prime and well-connected area. The project offers spacious homes with contemporary architecture, quality construction, and a peaceful environment, making it an ideal choice for families and investors alike.",
    detailedDescription: "Tulsi Patra is strategically situated near major transportation hubs, shopping centers, schools, hospitals, and other essential conveniences. Residents can enjoy excellent connectivity, ample natural light, well-planned layouts, and a lifestyle that combines comfort with convenience. With its attractive location and premium amenities, Tulsi Patra presents an excellent opportunity for those seeking a quality residential investment or a dream home.",

    // Date Information
    listingDate: "2026-05-24",
    lastUpdated: "2026-05-24",
    constructionYear: 2024,
    possessionDate: "Immediate",

    // Property Statistics
    viewCount: 1245,
    savedCount: 87,
    enquiriesCount: 23,
    daysListed: 45,

    // Basic Details
    beds: 4,
    baths: 3,
    area: "3200 sqft",
    builtUpArea: "3200 sqft",
    carpetArea: "2800 sqft",
    floor: "2nd floor",
    totalFloors: "1",
    age: "2 years",
    facing: "East",
    propertyType: "Residential Villa",
    status: "Ready to Move",

    // Amenities
    amenities: ["Swimming Pool", "Gym", "Park", "24/7 Security", "Power Backup", "Car Parking", "Garden", "Lift", "Club House"],
    interiorFeatures: ["Modular Kitchen", "Wooden Flooring", "Wardrobes", "AC", "Geyser", "False Ceiling"],

    // Nearby Places
    nearby: [
      { name: "Ankleshwar Railway Station", distance: "3.2 km", icon: "🚆" },
      { name: "D'Mart", distance: "1 km", icon: "🛍️" },
      { name: "Shubham K Mart", distance: "1 km", icon: "🛒" },
      { name: "GSRTC Bus Depo", distance: "3.5 km", icon: "🚌" },
      { name: "Ankleshwar City Center", distance: "2.5 km", icon: "🏙️" },
      { name: "Bharuch Railway Station", distance: "8 km", icon: "🚆" }
    ],

    // Price History
    priceHistory: [
      { date: "Jan 2023", price: "₹ 8.0 Cr" },
      { date: "Jun 2023", price: "₹ 7.8 Cr" },
      { date: "Nov 2023", price: "₹ 7.5 Cr" }
    ],

    // Property Timeline
    timeline: [
      { date: "Jan 2020", event: "Construction Started", icon: "🏗️" },
      { date: "Dec 2020", event: "Construction Completed", icon: "✅" },
      { date: "Mar 2021", event: "RERA Registration", icon: "📜" },
      { date: "Nov 2023", event: "Listed for Sale", icon: "🏷️" }
    ],

    // Legal Documents
    documents: {
      reraRegistered: true,
      ownership: "Freehold",
      approvedBy: ["Municipal Corporation", "Fire Department"],
      taxPaid: true,
      legalClearance: true,
      encumbranceFree: true
    },

    // Measurements
    measurements: {
      plotArea: "4000 sqft",
      builtUpArea: "3200 sqft",
      carpetArea: "2800 sqft",
      balconyArea: "300 sqft",
      parkingArea: "200 sqft (2 cars)"
    },

    // Room Details
    rooms: [
      { type: "Master Bedroom", size: "300 sqft", attachedBath: true, balcony: true },
      { type: "Bedroom 2", size: "250 sqft", attachedBath: false, balcony: true },
      { type: "Living Room", size: "400 sqft", facing: "East" },
      { type: "Kitchen", size: "200 sqft", modular: true }
    ],

    // Builder Information
    builder: "Haresh Purshotam",
    builderRating: 4.8,
    projectsCompleted: 25,

    reraId: "",
    possession: "Immediate",
    maintenance: "₹ 15000/Year",

    // Agent Information
    agent: {
      name: "BG RealEstate 360",
      phone: "+91 8487916787",
      email: "info@bgrealestate360.com",
      photo: "",
      experience: "",
      propertiesSold: "",
      rating: ""
    },

    isFavorite: false
  },
  {
    id: 102,
    title: "Satyam Residency",
    price: "₹ 2.8 Crore",
    pricePerSqft: "₹ 18,500/sqft",
    plotArea: "551 sqft",
    location: "Rajpipla Chowkadi NH-48,opp.Varsha Hotel",
    address: "Rajpipla Chowkadi NH-48,opp.Varsha Hotel  ",
    image: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00",
    images: [
      Satyam1,
      Satyam2,
      Satyam3,
      Satyam4,
      Satyam5,
      Satyam6
    ],
    type: "Row House - For Sale",
    description: "Welcome to Satyam Residency, where modern architecture meets everyday comfort. Designed with attention to detail, this residential development offers spacious homes, a peaceful environment, and easy access to all essential amenities. Its strategic location ensures seamless connectivity to transportation hubs, educational institutions, healthcare facilities, and shopping destinations.",
    detailedDescription: "With quality construction, thoughtfully planned spaces, and a family-friendly atmosphere, Satyam Residency provides an ideal setting for a comfortable and fulfilling lifestyle. It is the perfect choice for homebuyers seeking convenience, value, and long-term investment potential.",

    // Date Information
    listingDate: "2026-05-24",
    lastUpdated: "2026-05-24",
    constructionYear: "",
    possessionDate: "Immediate",

    // Property Statistics
    viewCount: 892,
    savedCount: 45,
    enquiriesCount: 18,
    daysListed: 30,

    // Basic Details
    beds: 3,
    baths: 3,
    area: "1500 sqft",
    builtUpArea: "1500 sqft",
    carpetArea: "1350 sqft",
    floor: "18th floor",
    totalFloors: "1",
    age: "",
    facing: "",
    propertyType: "Residential",
    status: "Ready to Move",

    // Amenities
    amenities: ["Swimming Pool", "Gym", "Club House", "Children's Play Area", "24/7 Security", "Power Backup", "Car Parking", "Garden", "Lift", "Jogging Track"],
    interiorFeatures: ["Modular Kitchen", "Marble Flooring", "Wardrobes", "AC", "Geyser", "False Ceiling", "Modular Wardrobes"],

    // Nearby Places
    nearby: [
      { name: "Ankleshwar Railway Station", distance: "3.2 km", icon: "🚆" },
      { name: "D'Mart", distance: "1 km", icon: "🛍️" },
      { name: "Shubham K Mart", distance: "2 km", icon: "🛒" },
      { name: "GSRTC Bus Depo", distance: "3.5 km", icon: "🚌" },
      { name: "Ankleshwar City Center", distance: "2.5 km", icon: "🏙️" },
      { name: "Bharuch Railway Station", distance: "9 km", icon: "🚆" }
    ],

    // Price History
    priceHistory: [
      { date: "Mar 2023", price: "₹ 3.0 Cr" },
      { date: "Sep 2023", price: "₹ 2.9 Cr" },
      { date: "Dec 2023", price: "₹ 2.8 Cr" }
    ],

    // Property Timeline
    timeline: [
      { date: "Jan 2017", event: "Construction Started", icon: "🏗️" },
      { date: "Dec 2018", event: "Construction Completed", icon: "✅" },
      { date: "Jun 2019", event: "RERA Registration", icon: "📜" },
      { date: "Dec 2023", event: "Listed for Sale", icon: "🏷️" }
    ],

    // Legal Documents
    documents: {
      reraRegistered: true,
      ownership: "Freehold",
      approvedBy: ["Municipal Corporation", "Environmental Department"],
      taxPaid: true,
      legalClearance: true,
      encumbranceFree: true
    },

    // Measurements
    measurements: {
      plotArea: "1800 sqft",
      builtUpArea: "1500 sqft",
      carpetArea: "1350 sqft",
      balconyArea: "200 sqft",
      parkingArea: "150 sqft (1 car)"
    },

    // Room Details
    rooms: [
      { type: "Master Bedroom", size: "250 sqft", attachedBath: true, balcony: true },
      { type: "Bedroom 2", size: "200 sqft", attachedBath: true, balcony: false },
      { type: "Bedroom 3", size: "180 sqft", attachedBath: false, balcony: false },
      { type: "Living Room", size: "300 sqft", facing: "West" },
      { type: "Kitchen", size: "150 sqft", modular: true }
    ],

    // Builder Information
    builder: "",
    builderRating: 4.7,
    projectsCompleted: 42,

    reraId: "",
    possession: "Immediate",
    maintenance: "",

    // Agent Information
    agent: {
      name: "BG RealEstate 360",
      phone: "+91 8487916787",
      email: "info@bgrealestate360.com",
      photo: "",
      experience: "",
      propertiesSold: "",
      rating: ""
    },


    isFavorite: true
  },
  {
    id: 103,
    title: "Nilkanth Varni Bungalow",
    price: "₹ 1.9 Crore",
    pricePerSqft: "₹ 22,000/sqft",
    plotArea: "560 sqft",
    location: "800 mtrs ahead of Gadkhol Patiya, Opp. Aiyappa Mandir, Ankleshwar.",
    address: "800 mtrs ahead of Gadkhol Patiya, Opp. Aiyappa Mandir, Ankleshwar.",
    image: "https://images.unsplash.com/photo-1518780664697-55e3ad937233",
    images: [
      "https://images.unsplash.com/photo-1518780664697-55e3ad937233",
      "https://images.unsplash.com/photo-1518780664697-55e3ad937233"
    ],
    type: "Row House - For Sale",
    description: "Welcome to Nilkanth Varni Bungalow, where luxury, comfort, and modern living come together. Designed with meticulous attention to detail, this elegant bungalow offers spacious rooms, contemporary finishes, and a sophisticated lifestyle in a peaceful residential setting.",
    detailedDescription: "Its strategic location provides easy access to major transportation routes, educational institutions, healthcare facilities, shopping destinations, and entertainment hubs. Surrounded by a welcoming community and equipped with modern conveniences, Nilkanth Varni Bungalow is an ideal choice for families seeking a refined living experience and long-term value.",

    // Date Information
    listingDate: "2026-05-24",
    lastUpdated: "2026-05-24",
    constructionYear: 2026,
    possessionDate: "Immediate",

    // Property Statistics
    viewCount: 678,
    savedCount: 32,
    enquiriesCount: 14,
    daysListed: 40,

    // Basic Details
    beds: 2,
    baths: 2,
    area: "850 sqft",
    builtUpArea: "850 sqft",
    carpetArea: "750 sqft",
    floor: "12th floor",
    totalFloors: "1",
    age: "6 Month",
    facing: "East-West",
    propertyType: "Residential Apartment",
    status: "Ready to Move",

    // Amenities
    amenities: ["Sea View", "24/7 Security", "Lift", "Power Backup", "Car Parking", "Gym", "Club House"],
    interiorFeatures: ["Modular Kitchen", "Vitrified Flooring", "Wardrobes", "AC", "Geyser"],

    // Nearby Places
    nearby: [
      { name: "Ankleshwar Railway Station", distance: "4 km", icon: "🚆" },
      { name: "D'Mart", distance: "2 km", icon: "🛍️" },
      { name: "Shubham K Mart", distance: "1.5 km", icon: "🛒" },
      { name: "GSRTC Bus Depo", distance: "5 km", icon: "🚌" },
      { name: "Ankleshwar City Center", distance: "4 km", icon: "🏙️" },
      { name: "Bharuch Railway Station", distance: "9 km", icon: "🚆" }
    ],

    // Price History
    priceHistory: [
      { date: "Jan 2023", price: "₹ 2.1 Cr" },
      { date: "Jul 2023", price: "₹ 2.0 Cr" },
      { date: "Nov 2023", price: "₹ 1.9 Cr" }
    ],

    // Property Timeline
    timeline: [
      { date: "Jan 2014", event: "Construction Started", icon: "🏗️" },
      { date: "Dec 2015", event: "Construction Completed", icon: "✅" },
      { date: "Jan 2016", event: "Occupancy Certificate", icon: "📜" },
      { date: "Nov 2023", event: "Listed for Sale", icon: "🏷️" }
    ],

    // Legal Documents
    documents: {
      reraRegistered: true,
      ownership: "Freehold",
      approvedBy: ["Municipal Corporation"],
      taxPaid: true,
      legalClearance: true,
      encumbranceFree: true
    },

    // Measurements
    measurements: {
      plotArea: "1200 sqft",
      builtUpArea: "850 sqft",
      carpetArea: "750 sqft",
      balconyArea: "100 sqft",
      parkingArea: "100 sqft (1 car)"
    },

    // Room Details
    rooms: [
      { type: "Master Bedroom", size: "200 sqft", attachedBath: true, balcony: true },
      { type: "Bedroom 2", size: "180 sqft", attachedBath: false, balcony: false },
      { type: "Living Room", size: "250 sqft", facing: "Sea" },
      { type: "Kitchen", size: "120 sqft", modular: true }
    ],

    // Builder Information
    builder: "",
    builderRating: 4.5,
    projectsCompleted: 18,

    reraId: "",
    possession: "Immediate",
    maintenance: "",

    // Agent Information
    agent: {
      name: "BG RealEstate 360",
      phone: "+91 8487916787",
      email: "info@bgrealestate360.com",
      photo: "",
      experience: "",
      propertiesSold: "",
      rating: ""
    },


    isFavorite: false
  },
  {
    id: 104,
    title: "Golden Nirvana 2/3 BHK",
    price: "₹ 5.2 Crore",
    pricePerSqft: "₹ 30,000/sqft",
    plotArea: "850 sqft",
    location: "Near Golden Villa, Ankleshwar-Bharuch Road",
    address: "Near Golden Villa, Ankleshwar-Bharuch Road",
    image: "https://images.unsplash.com/photo-1497366754035-f200968a6e72",
    images: [
      Golden1,
      Golden2
    ],
    type:"Appartment And Bunglow - For Sale",
    description: "Welcome to Nilkanth Varni Bungalow, where luxury, comfort, and modern living come together. Designed with meticulous attention to detail, this elegant bungalow offers spacious rooms, contemporary finishes, and a sophisticated lifestyle in a peaceful residential setting.",
    detailedDescription: "Its strategic location provides easy access to major transportation routes, educational institutions, healthcare facilities, shopping destinations, and entertainment hubs. Surrounded by a welcoming community and equipped with modern conveniences, Nilkanth Varni Bungalow is an ideal choice for families seeking a refined living experience and long-term value.",

    // Date Information
    listingDate: "2026-05-24",
    lastUpdated: "2026-05-24",
    constructionYear: 2025,
    possessionDate: "Immediate",

    // Property Statistics
    viewCount: 432,
    savedCount: 28,
    enquiriesCount: 12,
    daysListed: 25,

    // Basic Details
    beds: 0,
    baths: 4,
    area: "2000 sqft",
    builtUpArea: "2000 sqft",
    carpetArea: "1800 sqft",
    floor: "8th floor",
    totalFloors: "12",
    age: "",
    facing: "",
    propertyType: "Commercial Office",
    status: "Ready to Move",

    // Amenities
    amenities: ["AC", "Elevator", "Power Backup", "Security", "Parking", "Fire Safety", "Cafeteria", "Conference Room"],
    interiorFeatures: ["Modular Workstations", "False Ceiling", "LED Lighting", "CCTV", "Wi-Fi"],

    // Nearby Places
    nearby: [
      { name: "Ankleshwar Railway Station", distance: "3.2 km", icon: "🚆" },
      { name: "D'Mart", distance: "1 km", icon: "🛍️" },
      { name: "Shubham K Mart", distance: "1 km", icon: "🛒" },
      { name: "GSRTC Bus Depo", distance: "3.5 km", icon: "🚌" },
      { name: "Ankleshwar City Center", distance: "2.5 km", icon: "🏙️" },
      { name: "Bharuch Railway Station", distance: "8 km", icon: "🚆" }
    ],

    // Price History
    priceHistory: [
      { date: "Jun 2023", price: "₹ 5.5 Cr" },
      { date: "Oct 2023", price: "₹ 5.3 Cr" },
      { date: "Dec 2023", price: "₹ 5.2 Cr" }
    ],

    // Property Timeline
    timeline: [
      { date: "Jan 2018", event: "Construction Started", icon: "🏗️" },
      { date: "Dec 2019", event: "Construction Completed", icon: "✅" },
      { date: "Jan 2020", event: "Occupancy Certificate", icon: "📜" },
      { date: "Dec 2023", event: "Listed for Sale", icon: "🏷️" }
    ],

    // Legal Documents
    documents: {
      reraRegistered: true,
      ownership: "Leasehold",
      approvedBy: ["Municipal Corporation", "Fire Department", "Environmental Dept"],
      taxPaid: true,
      legalClearance: true,
      encumbranceFree: true
    },

    // Measurements
    measurements: {
      plotArea: "2000 sqft",
      builtUpArea: "2000 sqft",
      carpetArea: "1800 sqft",
      cabinArea: "400 sqft",
      workstationArea: "1000 sqft"
    },

    // Room Details
    rooms: [
      { type: "CEO Cabin", size: "200 sqft", attachedBath: true },
      { type: "Conference Room", size: "300 sqft" },
      { type: "Workstation Area", size: "1000 sqft" },
      { type: "Pantry", size: "100 sqft" }
    ],

    // Builder Information
    builder: "",
    builderRating: 4.9,
    projectsCompleted: 35,

    reraId: "",
    possession: "Immediate",
    maintenance: "",

    // Agent Information
    agent: {
      name: "BG RealEstate 360",
      phone: "+91 8487916787",
      email: "info@bgrealestate360.com",
      photo: "",
      experience: "",
      propertiesSold: "",
      rating: ""
    },


    isFavorite: false
  },
  {
    id: 105,
    title: " DEMO  Properties => Luxury Penthouse with Private Terrace",
    price: "₹ 12 Crore",
    pricePerSqft: "₹ 35,000/sqft",
    plotArea: "4000 sqft",
    location: "Lower Parel, Mumbai",
    address: "Senapati Bapat Marg, Lower Parel, Mumbai - 400013",
    image: "https://images.unsplash.com/photo-1616594039964-ae9021a400a0",
    images: [
      "https://images.unsplash.com/photo-1616594039964-ae9021a400a0",
      "https://images.unsplash.com/photo-1616594039964-ae9021a400a0"
    ],
    type: "Penthouse - For Sale",
    description: "Exclusive penthouse with private terrace, jacuzzi and panoramic city views.",
    detailedDescription: "This ultra-luxurious penthouse occupies the entire top floor of a premium high-rise. Features include a private terrace with jacuzzi, home theater, modular kitchen with premium appliances, and automated home systems. The property offers 360-degree views of Mumbai city.",

    // Date Information
    listingDate: "2023-11-25",
    lastUpdated: "2023-12-12",
    constructionYear: 2022,
    possessionDate: "Immediate",

    // Property Statistics
    viewCount: 756,
    savedCount: 65,
    enquiriesCount: 21,
    daysListed: 35,

    // Basic Details
    beds: 5,
    baths: 5,
    area: "3500 sqft",
    builtUpArea: "3500 sqft",
    carpetArea: "3200 sqft",
    floor: "28th floor",
    totalFloors: "28",
    age: "1 year",
    facing: "All Sides",
    propertyType: "Penthouse",
    status: "Ready to Move",

    // Amenities
    amenities: ["Private Terrace", "Jacuzzi", "Home Theater", "Servant Room", "Swimming Pool", "Gym", "24/7 Security", "Power Backup", "Car Parking", "Club House"],
    interiorFeatures: ["Smart Home", "Premium Kitchen", "Italian Marble", "Wardrobes", "AC", "Geyser", "False Ceiling"],

    // Nearby Places
    nearby: [
      { name: "High Street Phoenix", distance: "1 km", icon: "🛍️" },
      { name: "Parel Railway Station", distance: "2 km", icon: "🚆" },
      { name: "Hospital", distance: "3 km", icon: "🏥" },
      { name: "Five Star Hotel", distance: "500 m", icon: "🏨" },
      { name: "Business Park", distance: "1.5 km", icon: "🏢" },
      { name: "Fine Dining Restaurant", distance: "800 m", icon: "🍽️" }
    ],

    // Price History
    priceHistory: [
      { date: "Aug 2023", price: "₹ 13 Cr" },
      { date: "Oct 2023", price: "₹ 12.5 Cr" },
      { date: "Nov 2023", price: "₹ 12 Cr" }
    ],

    // Property Timeline
    timeline: [
      { date: "Jan 2020", event: "Construction Started", icon: "🏗️" },
      { date: "Dec 2022", event: "Construction Completed", icon: "✅" },
      { date: "Jan 2023", event: "RERA Registration", icon: "📜" },
      { date: "Nov 2023", event: "Listed for Sale", icon: "🏷️" }
    ],

    // Legal Documents
    documents: {
      reraRegistered: true,
      ownership: "Freehold",
      approvedBy: ["Municipal Corporation", "Fire Department", "Structural Engineer"],
      taxPaid: true,
      legalClearance: true,
      encumbranceFree: true
    },

    // Measurements
    measurements: {
      plotArea: "4000 sqft",
      builtUpArea: "3500 sqft",
      carpetArea: "3200 sqft",
      terraceArea: "500 sqft",
      parkingArea: "300 sqft (3 cars)"
    },

    // Room Details
    rooms: [
      { type: "Master Suite", size: "500 sqft", attachedBath: true, balcony: true },
      { type: "Bedroom 2", size: "350 sqft", attachedBath: true, balcony: true },
      { type: "Living Room", size: "600 sqft", facing: "City View" },
      { type: "Kitchen", size: "300 sqft", modular: true },
      { type: "Home Theater", size: "250 sqft" }
    ],

    // Builder Information
    builder: "Elite Developers",
    builderRating: 4.9,
    projectsCompleted: 28,

    reraId: "MHRERA333333333",
    possession: "Immediate",
    maintenance: "₹ 25,000/month",

    // Agent Information
    agent: {
      name: "BG RealEstate 360",
      phone: "+91 8487916787",
      email: "info@bgrealestate360.com",
      photo: "",
      experience: "",
      propertiesSold: "",
      rating: ""
    },


    isFavorite: true
  },
  {
    id: 106,
    title: " DEMO  Properties => Cozy 1BHK Studio Apartment",
    price: "₹ 85 Lakh",
    pricePerSqft: "₹ 21,000/sqft",
    plotArea: "650 sqft",
    location: "Andheri West, Mumbai",
    address: "Versova, Andheri West, Mumbai - 400053",
    image: "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688",
    images: [
      "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688",
      "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688"
    ],
    type: "Apartment - For Sale",
    description: "Compact and well-designed 1BHK studio apartment, fully furnished and ready to move in.",
    detailedDescription: "This beautifully designed 1BHK studio apartment is perfect for singles or couples. The apartment comes fully furnished with modern furniture, modular kitchen, and stylish interiors. Located in a well-maintained building with all basic amenities.",

    // Date Information
    listingDate: "2023-12-03",
    lastUpdated: "2023-12-19",
    constructionYear: 2016,
    possessionDate: "Immediate",

    // Property Statistics
    viewCount: 567,
    savedCount: 38,
    enquiriesCount: 16,
    daysListed: 27,

    // Basic Details
    beds: 1,
    baths: 1,
    area: "650 sqft",
    builtUpArea: "650 sqft",
    carpetArea: "580 sqft",
    floor: "4th floor",
    totalFloors: "7",
    age: "7 years",
    facing: "North",
    propertyType: "Studio Apartment",
    status: "Ready to Move",

    // Amenities
    amenities: ["Fully Furnished", "Modular Kitchen", "Parking", "24/7 Water", "Security", "Lift", "Power Backup"],
    interiorFeatures: ["Furniture Included", "Modular Kitchen", "Wooden Flooring", "Wardrobes", "AC", "Geyser"],

    // Nearby Places
    nearby: [
      { name: "Versova Beach", distance: "1.5 km", icon: "🏖️" },
      { name: "Metro Station", distance: "1 km", icon: "🚆" },
      { name: "Supermarket", distance: "500 m", icon: "🛒" },
      { name: "Hospital", distance: "2 km", icon: "🏥" },
      { name: "Restaurant", distance: "300 m", icon: "🍽️" },
      { name: "Bus Stop", distance: "200 m", icon: "🚌" }
    ],

    // Price History
    priceHistory: [
      { date: "Sep 2023", price: "₹ 90 Lakh" },
      { date: "Nov 2023", price: "₹ 87 Lakh" },
      { date: "Dec 2023", price: "₹ 85 Lakh" }
    ],

    // Property Timeline
    timeline: [
      { date: "Jan 2015", event: "Construction Started", icon: "🏗️" },
      { date: "Dec 2016", event: "Construction Completed", icon: "✅" },
      { date: "Jan 2017", event: "Occupancy Certificate", icon: "📜" },
      { date: "Dec 2023", event: "Listed for Sale", icon: "🏷️" }
    ],

    // Legal Documents
    documents: {
      reraRegistered: true,
      ownership: "Freehold",
      approvedBy: ["Municipal Corporation"],
      taxPaid: true,
      legalClearance: true,
      encumbranceFree: true
    },

    // Measurements
    measurements: {
      plotArea: "650 sqft",
      builtUpArea: "650 sqft",
      carpetArea: "580 sqft",
      balconyArea: "50 sqft",
      parkingArea: "50 sqft (1 bike)"
    },

    // Room Details
    rooms: [
      { type: "Studio Room", size: "400 sqft", attachedBath: true },
      { type: "Kitchen", size: "100 sqft", modular: true },
      { type: "Balcony", size: "50 sqft" }
    ],

    // Builder Information
    builder: "Versova Builders",
    builderRating: 4.3,
    projectsCompleted: 12,

    reraId: "MHRERA222222222",
    possession: "Immediate",
    maintenance: "₹ 2,500/month",

    // Agent Information
    agent: {
      name: "BG RealEstate 360",
      phone: "+91 8487916787",
      email: "info@bgrealestate360.com",
      photo: "",
      experience: "",
      propertiesSold: "",
      rating: ""
    },


    isFavorite: false
  },
  {
    id: 107,
    title: " DEMO  Properties => Farmhouse with Swimming Pool",
    price: "₹ 3.5 Crore",
    pricePerSqft: "₹ 8,000/sqft",
    plotArea: "1 Acre",
    location: "Lonavala",
    address: "Mumbai-Pune Highway, Lonavala - 410401",
    image: "https://images.unsplash.com/photo-1580587771525-78b9dba3b914",
    images: [
      "https://images.unsplash.com/photo-1580587771525-78b9dba3b914",
      "https://images.unsplash.com/photo-1580587771525-78b9dba3b914"
    ],
    type: "Farmhouse - For Sale",
    description: "Beautiful farmhouse with swimming pool, garden and mountain views in Lonavala.",
    detailedDescription: "This picturesque farmhouse is spread over 1 acre of land with fruit trees, vegetable garden, and a natural stream flowing nearby. The property features a 3BHK main house, separate servant quarter, swimming pool, and outdoor seating area. Perfect for weekend getaways or permanent residence.",

    // Date Information
    listingDate: "2023-11-10",
    lastUpdated: "2023-12-05",
    constructionYear: 2010,
    possessionDate: "Immediate",

    // Property Statistics
    viewCount: 423,
    savedCount: 52,
    enquiriesCount: 19,
    daysListed: 50,

    // Basic Details
    beds: 3,
    baths: 3,
    area: "4000 sqft",
    builtUpArea: "4000 sqft",
    carpetArea: "3500 sqft",
    floor: "Ground Floor",
    totalFloors: "1",
    age: "13 years",
    facing: "Valley",
    propertyType: "Farmhouse",
    status: "Ready to Move",

    // Amenities
    amenities: ["Swimming Pool", "Garden", "Parking", "24/7 Water", "Servant Quarter", "Outdoor Seating", "Fruit Garden"],
    interiorFeatures: ["Wooden Flooring", "Fireplace", "Wardrobes", "Geyser", "Traditional Kitchen"],

    // Nearby Places
    nearby: [
      { name: "Lonavala Lake", distance: "3 km", icon: "🏞️" },
      { name: "Market", distance: "5 km", icon: "🛍️" },
      { name: "Hospital", distance: "8 km", icon: "🏥" },
      { name: "School", distance: "10 km", icon: "🏫" },
      { name: "Railway Station", distance: "6 km", icon: "🚆" },
      { name: "Tiger Point", distance: "12 km", icon: "🌄" }
    ],

    // Price History
    priceHistory: [
      { date: "Jan 2023", price: "₹ 4.0 Cr" },
      { date: "Jul 2023", price: "₹ 3.8 Cr" },
      { date: "Nov 2023", price: "₹ 3.5 Cr" }
    ],

    // Property Timeline
    timeline: [
      { date: "Jan 2009", event: "Construction Started", icon: "🏗️" },
      { date: "Dec 2010", event: "Construction Completed", icon: "✅" },
      { date: "Jan 2011", event: "Property Registered", icon: "📜" },
      { date: "Nov 2023", event: "Listed for Sale", icon: "🏷️" }
    ],

    // Legal Documents
    documents: {
      reraRegistered: false,
      ownership: "Freehold",
      approvedBy: ["Gram Panchayat"],
      taxPaid: true,
      legalClearance: true,
      encumbranceFree: true
    },

    // Measurements
    measurements: {
      plotArea: "1 Acre",
      builtUpArea: "4000 sqft",
      carpetArea: "3500 sqft",
      gardenArea: "30000 sqft",
      parkingArea: "500 sqft (2 cars)"
    },

    // Room Details
    rooms: [
      { type: "Master Bedroom", size: "350 sqft", attachedBath: true, balcony: true },
      { type: "Bedroom 2", size: "300 sqft", attachedBath: true, balcony: false },
      { type: "Living Room", size: "500 sqft", facing: "Garden" },
      { type: "Kitchen", size: "250 sqft", modular: false }
    ],

    // Builder Information
    builder: "Local Builder",
    builderRating: 4.0,
    projectsCompleted: 8,

    reraId: "Not Applicable",
    possession: "Immediate",
    maintenance: "Self Maintained",

    // Agent Information
    agent: {
      name: "BG RealEstate 360",
      phone: "+91 8487916787",
      email: "info@bgrealestate360.com",
      photo: "",
      experience: "",
      propertiesSold: "",
      rating: ""
    },


    isFavorite: false
  },
  
  
];

export default function PropertyDetails() {
  const { id } = useParams();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showContactForm, setShowContactForm] = useState(false);
  const [showShareMenu, setShowShareMenu] = useState(false);
  const [isFavorite, setIsFavorite] = useState(false);
  const [contactData, setContactData] = useState({ name: "", phone: "", email: "", message: "" });
  const [copied, setCopied] = useState(false);

  const shareRef = useRef(null);
  const property = properties.find((item) => item.id === Number(id));

  // Click outside to close share menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (shareRef.current && !shareRef.current.contains(event.target)) {
        setShowShareMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    // Increment view count (simulated)
    console.log(`Property ${id} viewed`);
  }, [id]);

  if (!property) return <h2>Property Not Found</h2>;

  const handleNextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % property.images.length);
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + property.images.length) % property.images.length);
  };

  // const handleContactSubmit = (e) => {
  //   e.preventDefault();
  //   alert(`Thank you ${contactData.name}! Agent will contact you shortly.`);
  //   setShowContactForm(false);
  //   setContactData({ name: "", phone: "", email: "", message: "" });
  // };

  const handleWhatsApp = () => {
    const phone = property.agent.phone.replace(/\D/g, ""); // +91 remove
    const propertyUrl = `${window.location.origin}/property/${property.id}`;

    const message = `Hi, I'm interested in this property.

${property.title}
Property ID: ${property.id}
Link: ${propertyUrl}`;

    const whatsappUrl = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

    window.open(whatsappUrl, "_blank");
  };




 

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-IN', options);
  };

  const handleWhatsAppShare = () => {
    const message = `Check out this property: ${property.title}\nPrice: ${property.price}\nLocation: ${property.location}\nLink: ${window.location.href}`;
    window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, '_blank');
    setShowShareMenu(false);
  };

  const handleFacebookShare = () => {
    const url = encodeURIComponent(window.location.href);
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank', 'width=600,height=400');
    setShowShareMenu(false);
  };

  const handleTwitterShare = () => {
    const text = `Check out this property: ${property.title}`;
    const url = encodeURIComponent(window.location.href);
    window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${url}`, '_blank', 'width=600,height=400');
    setShowShareMenu(false);
  };

  const handleEmailShare = () => {
    const subject = `Property Listing: ${property.title}`;
    const body = `Check out this property:\n\n${property.title}\nPrice: ${property.price}\nLocation: ${property.location}\n\nView more details at: ${window.location.href}`;
    window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    setShowShareMenu(false);
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(window.location.href)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
        setShowShareMenu(false);
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
      });
  };

  return (
    <div className="pd-property-details-page">
      {/* Image Gallery Section */}
      <div className="pd-image-gallery-section">
        <div className="pd-main-image-container">
          <img
            src={property.images[currentImageIndex]}
            alt={`${property.title} - View ${currentImageIndex + 1}`}
            className="pd-main-image"
          />
          <button className="pd-nav-btn pd-prev-btn" onClick={handlePrevImage}>‹</button>
          <button className="pd-nav-btn pd-next-btn" onClick={handleNextImage}>›</button>
          <div className="pd-image-counter">{currentImageIndex + 1} / {property.images.length}</div>
          <button className="pd-favorite-btn" onClick={() => setIsFavorite(!isFavorite)}>
            <FaHeart className={isFavorite ? "pd-filled" : ""} />
          </button>

          {/* Share Button with Dropdown */}
          <div className="pd-share-container" ref={shareRef}>
            <button
              className="pd-share-btn"
              onClick={() => setShowShareMenu(!showShareMenu)}
            >
              <FaShareAlt />
            </button>

            {showShareMenu && (
              <div className="pd-share-dropdown">
                <h4 className="pd-share-title">Share Property</h4>
                <div className="pd-share-options">
                  <button className="pd-share-option" onClick={handleWhatsAppShare}>
                    <FaWhatsapp className="pd-whatsapp-icon" />
                    <span>WhatsApp</span>
                  </button>
                  <button className="pd-share-option" onClick={handleFacebookShare}>
                    <FaFacebook className="pd-facebook-icon" />
                    <span>Facebook</span>
                  </button>
                  <button className="pd-share-option" onClick={handleTwitterShare}>
                    <FaTwitter className="pd-twitter-icon" />
                    <span>Twitter</span>
                  </button>
                  <button className="pd-share-option" onClick={handleEmailShare}>
                    <FaEnvelope className="pd-email-icon" />
                    <span>Email</span>
                  </button>
                  <button className="pd-share-option" onClick={handleCopyLink}>
                    {copied ? (
                      <>
                        <FaCheck className="pd-copy-icon" />
                        <span>Copied!</span>
                      </>
                    ) : (
                      <>
                        <FaCopy className="pd-copy-icon" />
                        <span>Copy Link</span>
                      </>
                    )}
                  </button>
                </div>
                <div className="pd-share-url">
                  <input
                    type="text"
                    value={window.location.href}
                    readOnly
                    className="pd-url-input"
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="pd-thumbnail-container">
          {property.images.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`Thumbnail ${index + 1}`}
              className={`pd-thumbnail ${index === currentImageIndex ? 'pd-active' : ''}`}
              onClick={() => setCurrentImageIndex(index)}
            />
          ))}
        </div>
      </div>

      {/* Main Content */}
      <div className="pd-details-container">
        <div className="pd-main-content">
          {/* Header Section */}
          <div className="pd-property-header">
            <div className="pd-header-left">
              <h1 className="pd-property-title">{property.title}</h1>
              <div className="pd-location-section">
                <FaMapMarkerAlt className="pd-location-icon" />
                <span className="pd-property-address">{property.address}</span>
              </div>
              <div className="pd-property-tags">
                <span className="pd-tag pd-type">{property.type}</span>
                <span className="pd-tag pd-status">{property.status}</span>
                <span className="pd-tag pd-rera">RERA: {property.reraId}</span>
                <span className="pd-tag pd-date"><FaCalendar /> Listed: {formatDate(property.listingDate)}</span>
              </div>
            </div>

            <div className="pd-header-right">
              <div className="pd-price-section">
                {/* <h2 className="pd-property-price">{property.price}</h2> */}
                {/* <h2 className="pd-price-per-sqft">{property.pricePerSqft}</h2> */}
                <h2 className="pd-price-per-sqft"> Plot-Area:   {property.plotArea}</h2>
                <p className="pd-last-updated">Updated: {formatDate(property.lastUpdated)}</p>
              </div>
            </div>
          </div>

          {/* Property Statistics
          <div className="pd-property-stats">
            <div className="pd-stat-card">
              <FaEye className="pd-stat-icon" />
              <div className="pd-stat-info">
                <span className="pd-stat-number">{property.viewCount.toLocaleString()}</span>
                <span className="pd-stat-label">Views</span>
              </div>
            </div>
            <div className="pd-stat-card">
              <FaSave className="pd-stat-icon" />
              <div className="pd-stat-info">
                <span className="pd-stat-number">{property.savedCount}</span>
                <span className="pd-stat-label">Saved</span>
              </div>
            </div>
            <div className="pd-stat-card">
              <FaUsers className="pd-stat-icon" />
              <div className="pd-stat-info">
                <span className="pd-stat-number">{property.enquiriesCount}</span>
                <span className="pd-stat-label">Enquiries</span>
              </div>
            </div>
            <div className="pd-stat-card">
              <FaClock className="pd-stat-icon" />
              <div className="pd-stat-info">
                <span className="pd-stat-number">{property.daysListed}</span>
                <span className="pd-stat-label">Days Listed</span>
              </div>
            </div>
          </div> */}

          {/* Quick Stats */}
          {/* <div className="pd-quick-stats">
            <div className="pd-stat">
              <FaBed className="pd-stat-icon" />
              <div className="pd-stat-content">
                <span className="pd-stat-value">{property.beds}</span>
                <span className="pd-stat-label">Beds</span>
              </div>
            </div>
            <div className="pd-stat">
              <FaBath className="pd-stat-icon" />
              <div className="pd-stat-content">
                <span className="pd-stat-value">{property.baths}</span>
                <span className="pd-stat-label">Baths</span>
              </div>
            </div>
            <div className="pd-stat">
              <FaRulerCombined className="pd-stat-icon" />
              <div className="pd-stat-content">
                <span className="pd-stat-value">{property.area}</span>
                <span className="pd-stat-label">Built-up</span>
              </div>
            </div>
            <div className="pd-stat">
              <FaRulerCombined className="pd-stat-icon" />
              <div className="pd-stat-content">
                <span className="pd-stat-value">{property.carpetArea}</span>
                <span className="pd-stat-label">Carpet</span>
              </div>
            </div>
            <div className="pd-stat">
              <FaBuilding className="pd-stat-icon" />
              <div className="pd-stat-content">
                <span className="pd-stat-value">{property.floor}</span>
                <span className="pd-stat-label">Floor</span>
              </div>
            </div>
            <div className="pd-stat">
              <FaCalendar className="pd-stat-icon" />
              <div className="pd-stat-content">
                <span className="pd-stat-value">{property.age}</span>
                <span className="pd-stat-label">Age</span>
              </div>
            </div>
          </div> */}

          {/* Description Section */}
          <div className="pd-description-section">
            <h3 className="pd-section-title">Description</h3>
            <p className="pd-property-description">{property.description}</p>
            <p className="pd-detailed-description">{property.detailedDescription}</p>

            <div className="pd-property-features">
              <div className="pd-feature">
                <span className="pd-feature-label"><FaBuilding /> Facing:</span>
                <span className="pd-feature-value">{property.facing}</span>
              </div>
              <div className="pd-feature">
                <span className="pd-feature-label"><FaHome /> Total Floors:</span>
                <span className="pd-feature-value">{property.totalFloors}</span>
              </div>
              <div className="pd-feature">
                <span className="pd-feature-label"><FaCity /> Builder:</span>
                <span className="pd-feature-value">{property.builder}</span>
              </div>
              <div className="pd-feature">
                <span className="pd-feature-label"><FaCalendar /> Construction Year:</span>
                <span className="pd-feature-value">{property.constructionYear}</span>
              </div>
              <div className="pd-feature">
                <span className="pd-feature-label"><FaParking /> Maintenance:</span>
                <span className="pd-feature-value">{property.maintenance}</span>
              </div>
              <div className="pd-feature">
                <span className="pd-feature-label"><FaCalendarAlt /> Possession:</span>
                <span className="pd-feature-value">{property.possession}</span>
              </div>
            </div>
          </div>

          {/* Property Timeline */}
          <div className="pd-timeline-section">
            <h3 className="pd-section-title">Property Timeline</h3>
            <div className="pd-timeline">
              {property.timeline.map((item, index) => (
                <div key={index} className="pd-timeline-item">
                  <div className="pd-timeline-icon">{item.icon}</div>
                  <div className="pd-timeline-content">
                    <span className="pd-timeline-date">{item.date}</span>
                    <span className="pd-timeline-event">{item.event}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Price History */}
          <div className="pd-price-history-section">
            <h3 className="pd-section-title">Price History <FaChartLine /></h3>
            <div className="pd-price-history">
              {property.priceHistory.map((item, index) => (
                <div key={index} className="pd-price-item">
                  <div className="pd-price-date">{item.date}</div>
                  <div className="pd-price-amount">{item.price}</div>
                  {index < property.priceHistory.length - 1 && (
                    <div className={`pd-price-change ${parseFloat(item.price) > parseFloat(property.priceHistory[index + 1].price)
                      ? 'pd-decrease'
                      : 'pd-increase'
                      }`}>
                      {parseFloat(item.price) > parseFloat(property.priceHistory[index + 1].price) ? '↘' : '↗'}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>




{/* Price History */}
<div className="phx-price-history-section">
  <h3 className="phx-section-title">
    Price History <FaChartLine />
  </h3>

  <div className="phx-price-history">
    {property.priceHistory.map((item, index) => (
      <div key={index} className="phx-price-item">
        <div className="phx-price-date">{item.date}</div>
        <div className="phx-price-amount">{item.price}</div>

        {index < property.priceHistory.length - 1 && (
          <div
            className={`phx-price-change ${
              parseFloat(item.price) >
              parseFloat(property.priceHistory[index + 1].price)
                ? "phx-decrease"
                : "phx-increase"
            }`}
          >
            {parseFloat(item.price) >
            parseFloat(property.priceHistory[index + 1].price)
              ? "↘"
              : "↗"}
          </div>
        )}
      </div>
    ))}
  </div>
</div>

             










          {/* Legal Documents */}
          <div className="pd-documents-section">
            <h3 className="pd-section-title">Legal Documents <FaFileAlt /></h3>
            <div className="pd-documents-grid">
              <div className={`pd-document-item ${property.documents.reraRegistered ? 'pd-verified' : ''}`}>
                <span className="pd-document-label">RERA Registered</span>
                <span className="pd-document-status">
                  {property.documents.reraRegistered ? '✓ Verified' : '✗ Pending'}
                </span>
              </div>
              <div className={`pd-document-item ${property.documents.legalClearance ? 'pd-verified' : ''}`}>
                <span className="pd-document-label">Legal Clearance</span>
                <span className="pd-document-status">
                  {property.documents.legalClearance ? '✓ Clear' : '✗ Pending'}
                </span>
              </div>
              <div className={`pd-document-item ${property.documents.taxPaid ? 'pd-verified' : ''}`}>
                <span className="pd-document-label">Tax Paid</span>
                <span className="pd-document-status">
                  {property.documents.taxPaid ? '✓ Up to date' : '✗ Pending'}
                </span>
              </div>
              <div className={`pd-document-item ${property.documents.encumbranceFree ? 'pd-verified' : ''}`}>
                <span className="pd-document-label">Encumbrance Free</span>
                <span className="pd-document-status">
                  {property.documents.encumbranceFree ? '✓ Clear' : '✗ Pending'}
                </span>
              </div>
            </div>
          </div>

          {/* Amenities Section */}
          {/* <div className="pd-amenities-section">
            <h3 className="pd-section-title">Amenities & Features</h3>
            <div className="pd-amenities-grid">
              <div className="pd-amenity-category">
                <h4><FaBuilding /> Building Amenities</h4>
                <ul className="pd-amenity-list">
                  {property.amenities.map((amenity, index) => (
                    <li key={index}><FaShieldAlt className="pd-amenity-icon" /> {amenity}</li>
                  ))}
                </ul>
              </div>
              <div className="pd-amenity-category">
                <h4><FaHome /> Interior Features</h4>
                <ul className="pd-amenity-list">
                  {property.interiorFeatures.map((feature, index) => (
                    <li key={index}><FaTree className="pd-amenity-icon" /> {feature}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div> */}

          {/* Location & Nearby */}
          <div className="pd-location-section-details">
            <h3 className="pd-section-title">Location & Nearby</h3>
            <div className="pd-nearby-places">
              {property.nearby.map((place, index) => (
                <div key={index} className="pd-nearby-place">
                  <span className="pd-place-icon">{place.icon}</span>
                  <div className="pd-place-info">
                    <span className="pd-place-name">{place.name}</span>
                    <span className="pd-place-distance">{place.distance}</span>
                  </div>
                </div>
              ))}
            </div>
            {/* <div className="pd-map-placeholder">
              <div className="pd-map-frame">
                <FaMapMarkerAlt className="pd-map-icon" />
                <span className="pd-map-text">{property.location}</span>
                <button className="pd-view-map-btn">View on Map</button>
              </div>
            </div> */}
          </div>

          {/* EMI Calculator */}
          {/* <div className="pd-emi-section">
            <h3 className="pd-section-title">EMI Calculator</h3>
            <div className="pd-emi-calculator">
              <div className="pd-emi-result">
                <span className="pd-emi-label">Estimated Monthly EMI</span>
                <span className="pd-emi-value">₹ {calculateEMI()}</span>
              </div>
              <p className="pd-emi-note">*Based on 80% loan at 8.5% interest for 20 years</p>
              <button className="pd-btn-loan">Apply for Home Loan</button>
            </div>
          </div> */}

          {/* Room Details */}
          {/* <div className="pd-room-details-section">
            <h3 className="pd-section-title">Room Details</h3>
            <div className="pd-room-grid">
              {property.rooms.map((room, index) => (
                <div key={index} className="pd-room-card">
                  <h4 className="pd-room-type">{room.type}</h4>
                  <p className="pd-room-size">{room.size}</p>
                  <div className="pd-room-features">
                    {room.attachedBath && <span className="pd-room-feature">Attached Bath</span>}
                    {room.balcony && <span className="pd-room-feature">Balcony</span>}
                    {room.modular && <span className="pd-room-feature">Modular</span>}
                    {room.facing && <span className="pd-room-feature">{room.facing} facing</span>}
                  </div>
                </div>
              ))}
            </div>
          </div> */}
        </div>

        {/* Sidebar - Contact & Agent */}
        <div className="pd-sidebar">
          <div className="pd-agent-card">
            {/* <div className="pd-agent-header">
              <img src={property.agent.photo} alt={property.agent.name} className="pd-agent-photo" />
              <div className="pd-agent-info">
                <h4 className="pd-agent-name">{property.agent.name}</h4>
                <p className="pd-agent-role">Certified Real Estate Agent</p>
                <div className="pd-agent-rating">
                  <span className="pd-rating-stars">★★★★★</span>
                  <span className="pd-rating-value">{property.agent.rating}</span>
                </div>
                <p className="pd-agent-experience"><FaCalendar /> {property.agent.experience} experience</p>
                <p className="pd-agent-sold"><FaUsers /> {property.agent.propertiesSold} properties sold</p>
              </div>
            </div> */}

            <div className="pd-contact-buttons">
              <button className="pd-btn-call" onClick={() => window.location.href = `tel:${property.agent.phone}`}>
                <FaPhone /> Call Now
              </button>
              <button className="pd-btn-whatsapp" onClick={handleWhatsApp}>
                <FaWhatsapp /> WhatsApp
              </button>
              {/* <button className="pd-btn-schedule" onClick={() => setShowContactForm(true)}>
                <FaCalendarAlt /> Schedule Visit
              </button> */}
            </div>

            <div className="pd-quick-actions">
              {/* <button className="pd-btn-download">
                <FaFileAlt /> Download Brochure
              </button> */}
              {/* <button className="pd-btn-share" onClick={() => setShowShareMenu(true)}>
                <FaShareAlt /> Share Property
              </button> */}
              {/* <button className="pd-btn-print">Print Details</button> */}
            </div>

            {/* Important Dates */}
            <div className="pd-important-dates">
              <h4>Important Dates</h4>
              <div className="pd-date-item">
                <span className="pd-date-label">Listed On:</span>
                <span className="pd-date-value">{formatDate(property.listingDate)}</span>
              </div>
              <div className="pd-date-item">
                <span className="pd-date-label">Last Updated:</span>
                <span className="pd-date-value">{formatDate(property.lastUpdated)}</span>
              </div>
              <div className="pd-date-item">
                <span className="pd-date-label">Construction Year:</span>
                <span className="pd-date-value">{property.constructionYear}</span>
              </div>
              <div className="pd-date-item">
                <span className="pd-date-label">Property Age:</span>
                <span className="pd-date-value">{property.age}</span>
              </div>
            </div>
          </div>

          {/* Contact Form Modal */}
          {/* {showContactForm && (
            <div className="pd-contact-modal">
              <div className="pd-modal-content">
                <h3>Schedule a Visit</h3>
                <form onSubmit={handleContactSubmit}>
                  <input
                    type="text"
                    placeholder="Your Name"
                    value={contactData.name}
                    onChange={(e) => setContactData({ ...contactData, name: e.target.value })}
                    required
                  />
                  <input
                    type="tel"
                    placeholder="Phone Number"
                    value={contactData.phone}
                    onChange={(e) => setContactData({ ...contactData, phone: e.target.value })}
                    required
                  />
                  <input
                    type="email"
                    placeholder="Email Address"
                    value={contactData.email}
                    onChange={(e) => setContactData({ ...contactData, email: e.target.value })}
                  />
                  <textarea
                    placeholder="Message or Preferred time for visit"
                    value={contactData.message}
                    onChange={(e) => setContactData({ ...contactData, message: e.target.value })}
                  />
                  <div className="pd-modal-buttons">
                    <button type="submit" className="pd-btn-submit">Submit Request</button>
                    <button type="button" className="pd-btn-cancel" onClick={() => setShowContactForm(false)}>
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )} */}
        </div>
      </div>
    </div>
  );
}